import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import { useRouter } from 'vue-router/composables'

import { api } from '../adminApi'


export default /*#__PURE__*/_defineComponent({
  __name: 'NewPATView',
  setup(__props) {


const description = ref('')
const isFormValid = ref(false)

const router = useRouter()

function validateDescription(description: string): boolean {
    return Boolean(description)
}

async function generate() {

  try {
    const createTokenResponse = await api.createToken()
    await api.updateToken(createTokenResponse.data.token, {
      description: description.value
    })
  } catch (error) {
    console.log(error)
  }

  router.push({ name: 'pats' })
}


return { __sfc: true,description, isFormValid, router, validateDescription, generate }
}

})